import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useCurrentProject } from '../contexts/AccountProjectContext';

export const useSyncProjectIdToForm = () => {
  const { projectId } = useCurrentProject();
  const form = useFormContext();
  useEffect(() => {
    if (form && projectId !== undefined) {
      form.setValue('projectId', projectId);
    }
  }, [form, projectId]);
  return projectId;
};
